import React from 'react'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
import {DesktopDatePicker} from '@mui/x-date-pickers'
import _ from 'lodash'

interface FormikDatePickerProps {
    id: string
    onChange?(...args: unknown[]): unknown
    formik: any
    className?: string
    maxDays?: number
    disabled?: boolean
}

const FormikDatePicker = ({
    id,
    onChange,
    formik,
    className,
    maxDays,
    disabled
}: FormikDatePickerProps) => {
    const currentDate = new Date()
    const maxDate = new Date(currentDate.getTime() + (maxDays ?? 30) * 24 * 60 * 60 * 1000)
    const minDate = new Date(currentDate.getTime() - 1 * 24 * 60 * 60 * 1000)

    const handleChange = (date) => {
        if (onChange) onChange(date)
        formik.setFieldValue(id, date)
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
                value={_.get(formik.values, id)}
                onChange={handleChange}
                slotProps={{
                    textField: {
                        id,
                        disabled: true
                    },
                    popper: {
                        style: {
                            zIndex: 1301
                        }
                    }
                }}
                label=''
                format={'EEE, MMM dd'}
                minDate={minDate}
                maxDate={maxDate}
                className={className}
                disabled={disabled}
            />
        </LocalizationProvider>
    )
}

FormikDatePicker.defaultProps = {
    onChange: () => {},
    maxDays: 30,
    disabled: false
}

export default FormikDatePicker
